import app from '@/main.js'

async function messageDelete ({ userId, messageId }) {
  return await app.wsp.sendRequest({
    data: {
      userId: userId,
      id: messageId
    },
    method: 'message.delete'
  })
}

export default messageDelete